import React from 'react';
import styles from './styles.module.css';
import { formatPortion } from './mealPlanModel';

/**
 * Um item da refeição como o paciente vê: alimento com a porção à direita,
 * a observação logo abaixo e as substituições recuadas, marcadas como "ou".
 */
const MealItemRow = ({ item }) => {
  const portion = formatPortion(item);
  const substitutes = item.substitutes || [];

  return (
    <li className={styles.item}>
      <div className={styles.itemRow}>
        <span className={styles.itemFood}>{item.food}</span>
        {portion && <span className={styles.itemPortion}>{portion}</span>}
      </div>
      {item.note && <span className={styles.itemNote}>{item.note}</span>}
      {substitutes.length > 0 && (
        <ul className={styles.substitutes}>
          {substitutes.map((sub) => {
            const subPortion = formatPortion(sub);
            return (
              <li key={sub.key} className={styles.substitute}>
                <span className={styles.substituteTag}>ou</span>
                <span>{sub.food}{subPortion && `, ${subPortion}`}</span>
              </li>
            );
          })}
        </ul>
      )}
    </li>
  );
};

export default MealItemRow;
